import styled from "styled-components";

export const Background = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    background-repeat: no-repeat;
    background-size: cover;
  }
  @media (max-width: 360px) {
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export const Container = styled.div`
  display: flex;
  margin: 0 84px 0 122px;
  height: 64px;
  padding: 18px 0;
  justify-content: space-between;
  aliten-items: center;

  a {
    display: flex;
  }
  @media (max-width: 1024px) {
    margin: 0 10px;
  }

  ${"" /* @media (max-width: 600px) {
    margin-bottom: 90px;
  } */}
`;

export const Logo = styled.a`
  width: 432px;
  height: 70px;
  background-size: cover;
  background-image: url("/images/icons/Logo (2).png");
  @media (max-width: 600px) {
    width: 200px;
    height: 70px;
    background-size: cover;
    background-image: url("/images/vmsphotos/logo2.png");
  }
`;
